import {
  ACTION_LOAD_SITE_GOOGLE_TOOL__REQUEST,
  ACTION_LOAD_SITE_GOOGLE_TOOL__SUCCESS,
  ACTION_LOAD_SITE_GOOGLE_TOOL__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_LOAD_SITE_GOOGLE_TOOL__REQUEST:
    case ACTION_LOAD_SITE_GOOGLE_TOOL__SUCCESS:
      return null;

    case ACTION_LOAD_SITE_GOOGLE_TOOL__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
